import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Add from '@mui/icons-material/Add';
import Delete from '@mui/icons-material/Delete';
import { SectionHeader } from '../components/SectionHeader';
import { SectionInfoBanner } from '../components/SectionInfoBanner';
import { StoreTabFooter } from '../components/StoreTabFooter';
import {
  MAX_SEARCH_KEYWORDS,
  SS_OUTLINED_INPUT,
  ssFieldSx,
  ssAddRowButtonSx,
} from '../storeSettingsConstants';

export function SearchKeywordsSection({
  meta,
  form,
  updateKeyword,
  addKeyword,
  removeKeyword,
  tabFooterProps,
}) {
  const keywordRows = [];
  for (let i = 0; i < form.search_key_words.length; i += 2) {
    keywordRows.push([
      { kw: form.search_key_words[i], idx: i },
      form.search_key_words[i + 1] != null
        ? { kw: form.search_key_words[i + 1], idx: i + 1 }
        : null,
    ]);
  }

  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      <SectionInfoBanner title='What this tab controls'>
        <div>
          Add keywords customers may use to find your store, including your top-selling dishes. Use
          clear, relevant terms to improve your visibility in search results.
        </div>
      </SectionInfoBanner>

      <div className='store-settings-list-block'>
        <div className='store-settings-list-header'>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#181436', marginBottom: 2 }}>
              Add or edit search keywords
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>
              Up to 10 searchable keywords allowed.
            </div>
          </div>
          <span className='store-settings-count-badge'>
            {form.search_key_words.length} / {MAX_SEARCH_KEYWORDS}
          </span>
        </div>

        {form.search_key_words.length === 0 && (
          <p className='store-settings-helper-text store-settings-empty-hint'>
            No keywords yet - click &quot;Add keyword&quot; to start.
          </p>
        )}

        {keywordRows.map((pair, rowIdx) => (
          <Box
            key={`kw-row-${rowIdx}`}
            sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 1.8 }}
          >
            {pair.map((entry, colIdx) => {
              if (!entry) return <Box key={`kw-empty-${rowIdx}-${colIdx}`} />;
              const { kw, idx } = entry;
              return (
                <Box key={`kw-${idx}`} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <TextField
                    id={`search_kw_${idx}`}
                    className={SS_OUTLINED_INPUT}
                    size='small'
                    label={`Keyword ${idx + 1}`}
                    value={kw}
                    onChange={(e) => updateKeyword(idx, e.target.value)}
                    placeholder='e.g. chicken biryani'
                    variant='outlined'
                    sx={{ ...ssFieldSx, flex: 1 }}
                  />
                  {form.search_key_words.length > 1 && (
                    <IconButton
                      onClick={() => removeKeyword(idx)}
                      color='error'
                      size='small'
                      aria-label={`Remove keyword ${idx + 1}`}
                    >
                      <Delete fontSize='small' />
                    </IconButton>
                  )}
                </Box>
              );
            })}
          </Box>
        ))}

        <Button
          variant='contained'
          startIcon={<Add />}
          onClick={addKeyword}
          disabled={form.search_key_words.length >= MAX_SEARCH_KEYWORDS}
          sx={ssAddRowButtonSx}
        >
          Add keyword
        </Button>
      </div>

      <StoreTabFooter tabId='7' {...tabFooterProps} />
    </>
  );
}
